/* eslint-disable no-unused-vars */
import { TimeEntryErrorModel } from './timeEntryErrorModel'
import ResultDTO from '@/models/app/resultDTO'
import TimeEntryAPIErrorContext from '@/constants/booking/timeEntries/TimeEntryAPIErrorContext'
import ErrorResponseDTO from '@/models/error/errorResponseDTO'

export class TimeEntryBookingsErrorModel extends TimeEntryErrorModel {
  /** @param {ResultDTO<ErrorResponseDTO>} errorResponse */
  constructor(errorResponse) {
    super(errorResponse, TimeEntryAPIErrorContext.bookings)

    /**
     * See {@link https://dev.azure.com/anzukeducation/Staffroom%20NEXT/_wiki/wikis/anzuk%20Dev%20Team/366/Ready2Work-2.0?anchor=get-/api/v1.0/time-entries/bookings Error Code Wiki}
     * @type {string[]}
     */
    this.errorCodesToRefresh = ['already_clocked_in', 'no_available_shifts']
  }

  /** @override */
  shouldTriggerTimeEntryStatusRefresh() {
    return this.errorCodesToRefresh.includes(this.errorCode)
  }
}
